// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - CARD ||============================== //

export default function Card(theme: Theme) {
	return {
		MuiCard: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.background.paper,
					borderColor: theme.palette.divider,
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundColor: theme.palette.background.paper,
				},
			},
		},
	};
}
